'use client'

import { cva, VariantProps } from 'class-variance-authority'
import { motion } from 'framer-motion'
import { FC, HTMLAttributes } from 'react'

import funkityIcon from '@/assets/funkity-icon.png'
import { cn } from '@/lib/utils'

export const spinnerVariants = cva('flex items-center justify-center', {
  defaultVariants: {
    layout: 'fullscreen',
  },
  variants: {
    layout: {
      fullscreen: 'h-screen w-screen',
      inline: 'h-[20px] w-[20px]',
      section: 'h-[200px]',
    },
  },
})

type Props = {
  size?: string
} & HTMLAttributes<HTMLElement> &
  VariantProps<typeof spinnerVariants>

/**
 * Full screen loading indicator.
 */
const FullScreenSpinner: FC<Props> = ({ layout, size = '100px', ...props }) => {
  return (
    <div {...props} className={cn(spinnerVariants({ layout }), props.className)}>
      <motion.img
        alt="Funkity"
        animate={{ scale: 1 }}
        initial={{ scale: 0.8 }}
        src={funkityIcon}
        style={{ height: size, width: 'auto' }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      />
    </div>
  )
}

export default FullScreenSpinner
